<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .content {
    display: flex;
    flex-direction: column;
    gap: 0;
    padding: 0;
    height: 100%;

    .main-section {
      display: flex;
      flex-direction: column;
      flex: 1 1 0%;
      gap: utils.in_rem(32px);
      padding: utils.in_rem(24px);
      min-height: 0;

      .heading {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        position: relative;

        .heading-text {
          display: flex;
          flex-direction: column;
          align-items: center;

          .title {
            @include mixins.h2();
            color: colors.get(black_90);
          }

          .subtitle {
            @include mixins.body2();
          }
        }

        .close-button {
          position: absolute;
          top: utils.in_rem(-8px);
          right: utils.in_rem(-8px);
        }
      }
    }
  }

  .cta-wrapper {
    margin: 0 utils.in_rem(24px);
    padding: utils.in_rem(12px) 0;
    align-self: stretch;
    align-items: center;
    border-top: 1px solid colors.get("interfaceSwGrey_10");
    flex-shrink: 0;

    .cta-buttons {
      display: flex;
      gap: utils.in_rem(24px);
      align-items: center;
      justify-content: center;
      align-self: stretch;
    }
  }
</style>

<script>
  import {
    userStore,
    usersStore,
  } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import Tooltip from "@sourcewhale/shared/svelte-design-system/components/atoms/Tooltip.svelte";
  import TextInput from "@sourcewhale/shared/svelte-design-system/components/molecules/InputFields/TextInput.svelte";
  import CloseButton from "@sourcewhale/shared/svelte-design-system/components/molecules/Modal/CloseButton.svelte";
  import Modal from "@sourcewhale/shared/svelte-design-system/components/molecules/Modal/Modal.svelte";
  import { adminsStore } from "../../../../api-stores/meetings-store";
  import { requestAccess } from "../../../../api/request-access";
  import AdminSelector from "./AdminSelector.svelte";
  import { LICENSE_TO_FEATURE } from "./assets";
  import { showRegisterInterestModal } from "./stores";

  let noteValue = $state("");
  let selectedAdmins = $state([]);
  let { license, registered = $bindable(false) } = $props();

  let feature = LICENSE_TO_FEATURE[license];

  let titleText = $derived(
    ["trial", "trialEnded"].includes($userStore[`${license}Plan`])
      ? `Request full access to ${feature}`
      : `Register interest for ${feature}`
  );

  let ctaText = $derived(
    ["trial", "trialEnded"].includes($userStore[`${license}Plan`])
      ? "Request Access"
      : "Register Interest"
  );

  let adminSelectionRequired = $derived($adminsStore.length > 1);

  const onclick = async () => {
    const adminsToNotify = adminSelectionRequired
      ? selectedAdmins
      : [$adminsStore[0].userId];
    await requestAccess(feature, {
      adminsToNotify,
      noteToAdmins: noteValue,
    });
    await userStore.get();
    registered = true;
  };

  let size = $derived(adminSelectionRequired ? "medium" : "");
  let modalContentsStyle = $derived(
    adminSelectionRequired ? "" : "width:500px"
  );
  const { meta } = usersStore;
  let disabled = $derived(
    $meta.fetching || (adminSelectionRequired && !selectedAdmins.length)
  );

  const onclose = () => {
    $showRegisterInterestModal = false;
  };
</script>

<Modal {onclose} {size} showHeader={false} {modalContentsStyle}>
  <div class="content">
    <div class="main-section">
      <div class="heading">
        <div class="heading-text">
          <span class="title">{titleText}</span>
          <span class="subtitle"
            >Let your admin know that you are interested in this feature</span
          >
        </div>
        <div class="close-button"><CloseButton {onclose} /></div>
      </div>
      <AdminSelector bind:selectedAdmins />
      <TextInput
        bind:value={noteValue}
        kind="textarea"
        label="Add a note (optional)"
        labelSize="large"
      />
    </div>
    <div class="cta-wrapper">
      <div class="cta-buttons">
        <Button kind="ghost-blue" size="large" onclick={onclose} class="flex-1"
          >Cancel</Button
        >
        {#if disabled}
          <div style="flex: 1; display: flex;">
            <Tooltip let:onmouseenter let:onmouseleave>
              <Button
                kind="primary disabled"
                size="large"
                disabled
                class="flex-1"
                {onmouseenter}
                {onmouseleave}>{ctaText}</Button
              >
              <span slot="tooltip" class="tooltip"
                >Select at least one admin...</span
              >
            </Tooltip>
          </div>
        {:else}
          <Button kind="primary" size="large" {onclick} class="flex-1"
            >{ctaText}</Button
          >
        {/if}
      </div>
    </div>
  </div>
</Modal>
